import ShortAnswer from './model';
import Item from './Item';
import { List } from 'immutable';

const reviver = ([key, val]) => {
  switch (key) {
    case 'shortAnswers': {
      if (Array.isArray(val)) {
        return [key, val.reduce((list, item) => list.push(Item.create(item)), new List())];
      }
      return [key, []];
    }
    case 'comment': {
      if (val) {
        return [key, val];
      }
      return [key, ''];
    }
    default:
      return [key, val];
  }
};

const create = (data) => new ShortAnswer(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/model/create.js